module.exports = __webpack_public_path__ + "static/media/curriculo2.482fd634.svg";